var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-card',{staticClass:"g-card",attrs:{"elevation":"0","flat":""}},[_c('header-section',_vm._g(_vm._b({},'header-section',_vm.header,false),_vm.onHeader)),_c('details-section',_vm._g(_vm._b({},'details-section',_vm.content,false),_vm.onContent))],1)
}
var staticRenderFns = []

export { render, staticRenderFns }